import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useLanguageStore, t } from '../stores/languageStore';

const TermsOfService: React.FC = () => {
  const { language } = useLanguageStore();
  const handleBack = () => {
    window.history.back();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <button
          onClick={handleBack}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-800 mb-8 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          {t('termsOfService.back')}
        </button>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-2xl font-bold text-gray-800 mb-6 text-center">
            {t('termsOfService.title')}
          </h1>

          <div className="prose prose-gray max-w-none">
            <p className="text-gray-600 mb-6">
              欢迎使用桃花坛（以下简称"本平台"、"本论坛"或"桃花坛"）。本协议是您与桃花坛之间的服务协议，请仔细阅读本协议的全部内容。本协议旨在明确双方的权利义务关系，特别是强调房主责任独立、平台不参与内容、真实性不做研判、用户自行承担风险等核心原则。
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              一、服务概述
            </h2>
            <p className="text-gray-600 mb-4">
              1.1 桃花坛是一个在线交流平台，为用户提供包括但不限于以下服务：
            </p>
            <ul className="text-gray-600 mb-4 list-disc list-inside">
              <li>创建和管理私人房间，进行私密交流</li>
              <li>购买房间会员，享受专属权益</li>
              <li>发布和浏览帖子、评论</li>
              <li>参与社区讨论和互动</li>
              <li>使用站内消息系统进行沟通</li>
              <li>捐赠和打赏功能</li>
              <li>网络存储空间服务</li>
              <li>其他增值服务</li>
            </ul>
            <p className="text-gray-600 mb-4">
              1.2 本平台提供的服务可能会根据业务发展进行调整和优化，桃花坛保留随时变更、暂停或终止部分或全部服务的权利，但会提前通知用户。
            </p>
            <p className="text-gray-600 mb-4">
              1.3 本平台的部分功能可能需要付费使用，付费功能的具体说明和价格以平台公示为准。
            </p>
            <p className="text-gray-600 mb-4">
              1.4 本平台遵循平等、自愿、公平、诚实信用的原则为用户提供服务。
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              二、用户注册与账号管理
            </h2>
            <p className="text-gray-600 mb-4">
              2.1 用户在使用本平台服务前，需要注册一个账号。注册时需提供真实、准确、完整的信息，包括但不限于用户名、邮箱地址等必要信息。
            </p>
            <p className="text-gray-600 mb-4">
              2.2 用户应妥善保管自己的账号和密码，对使用账号进行的所有活动负责。任何因账号泄露、被盗用或密码丢失导致的损失，由用户自行承担。
            </p>
            <p className="text-gray-600 mb-4">
              2.3 用户不得将账号转让、出租、出借、出售或以其他方式许可他人使用。如发现账号异常使用或存在安全风险，桃花坛有权暂停或终止该账号的使用。
            </p>
            <p className="text-gray-600 mb-4">
              2.4 用户应确保所提供的联系方式（如邮箱、手机号）准确有效，以便接收重要通知和验证信息。如联系方式变更，应及时更新。
            </p>
            <p className="text-gray-600 mb-4">
              2.5 用户理解并同意，桃花坛有权对用户的注册信息进行审核，并有权要求用户补充提供身份证明或其他材料以完成实名认证。
            </p>
            <p className="text-gray-600 mb-4">
              2.6 用户账号被暂停或终止后，将无法使用该账号登录本平台，已付费的服务可能无法获得退款。
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              三、用户权利与义务
            </h2>
            <p className="text-gray-600 mb-4">
              3.1 用户有权在遵守本协议的前提下使用本平台提供的各项服务。
            </p>
            <p className="text-gray-600 mb-4">
              3.2 用户有权对自己发布的内容进行编辑、修改或删除，但应承担相应责任。
            </p>
            <p className="text-gray-600 mb-4">
              3.3 用户应遵守国家法律法规、社会公德和公序良俗，不得利用本平台进行任何违法违规活动。
            </p>
            <p className="text-gray-600 mb-4">
              3.4 用户在本平台发布的内容必须符合法律法规和本协议的规定，不得包含以下内容：
            </p>
            <ul className="text-gray-600 mb-4 list-disc list-inside">
              <li>违反国家法律法规、行政法规或规章的内容</li>
              <li>危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一的内容</li>
              <li>损害国家荣誉和利益的内容</li>
              <li>煽动民族仇恨、民族歧视，破坏民族团结的内容</li>
              <li>破坏国家宗教政策，宣扬邪教和封建迷信的内容</li>
              <li>散布谣言，扰乱社会秩序，破坏社会稳定的内容</li>
              <li>涉及色情、暴力、恐怖、赌博、毒品等违法违规内容</li>
              <li>侮辱、诽谤他人，侵害他人合法权益的内容</li>
              <li>侵犯他人知识产权、隐私权、名誉权、肖像权等合法权益的内容</li>
              <li>虚假信息、误导性陈述或诈骗内容</li>
              <li>恶意攻击、诽谤、侮辱他人的内容</li>
              <li>含有商业广告性质的内容（除非经平台许可）</li>
              <li>垃圾信息、 spam 内容</li>
              <li>其他违反公序良俗或本平台规定的内容</li>
            </ul>
            <p className="text-gray-600 mb-4">
              3.5 用户应尊重其他用户的权利，不得干扰他人正常使用本平台服务，不得进行任何骚扰、恐吓、欺诈或其他恶意行为。
            </p>
            <p className="text-gray-600 mb-4">
              3.6 用户不得对本平台进行任何形式的破解、反编译、逆向工程，不得试图绕过或破解本平台的安全措施。
            </p>
            <p className="text-gray-600 mb-4">
              3.7 用户不得利用本平台从事洗钱、套现、转移非法资金等违法犯罪活动。
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              四、内容责任声明（核心条款）
            </h2>
            <p className="text-gray-600 mb-4">
              <strong>4.1 房主责任独立原则（最重要条款）</strong>
              <br />
              本平台仅提供技术服务和平台支持，不参与、不介入房主与用户之间的任何关系或交易。房主在其创建的房间内发表的言论、观点、信息、分析、建议等均为房主个人行为，与本平台无关。房主应对其在房间内发布的所有内容承担全部法律责任，包括但不限于民事责任、行政责任或刑事责任。
            </p>
            <p className="text-gray-600 mb-4">
              <strong>4.2 平台不参与内容原则</strong>
              <br />
              本平台对房主或其他用户在房间内发表的任何言论、观点、信息、分析、建议等不参与、不干预、不编辑。平台仅提供技术手段保障内容的正常展示和传输，不对内容本身负责。本平台不认可、保证或支持任何用户在平台上发表的内容。
            </p>
            <p className="text-gray-600 mb-4">
              <strong>4.3 真实性不做研判原则</strong>
              <br />
              本平台对用户发表的内容真实性、准确性、完整性、可靠性不做任何判断、验证、审查或保证。用户应自行甄别信息真伪，谨慎对待各类信息，特别是投资建议、分析观点、预测信息等。本平台不对因信息不实导致的任何损失、纠纷或后果承担责任。
            </p>
            <p className="text-gray-600 mb-4">
              <strong>4.4 不提供任何保证原则</strong>
              <br />
              本平台不保证用户发表的内容准确、完整、及时、可靠或适用于任何特定目的。用户使用内容时应自行评估其适用性、可靠性和风险。本平台按"现状"提供服务，不提供任何明示或暗示的保证。
            </p>
            <p className="text-gray-600 mb-4">
              <strong>4.5 投资建议免责声明（特别重要）</strong>
              <br />
              本平台内可能存在各类投资建议、分析观点、市场评论、预测信息等内容。用户应明白任何投资均存在风险，包括但不限于本金损失的风险。投资决策由用户自行做出，盈亏完全由用户自负。本平台不对任何投资损失、盈利或亏损承担责任，也不提供任何形式的投资咨询服务。任何自称能提供投资收益保证或预测市场走势的内容均为虚假信息。
            </p>
            <p className="text-gray-600 mb-4">
              <strong>4.6 交易双方责任原则</strong>
              <br />
              本平台上的交易（包括但不限于会员购买、付费服务等）仅在用户与本平台之间进行，不涉及第三方房主与用户的直接交易（除非另有说明）。对于任何因交易产生的纠纷，应由交易双方自行解决，本平台不承担任何责任。
            </p>
            <p className="text-gray-600 mb-4">
              <strong>4.7 第三方内容免责</strong>
              <br />
              本平台可能包含第三方提供的内容、广告或链接。对于第三方内容的真实性、合法性、安全性、可靠性，本平台不承担任何责任。用户访问第三方内容、广告或链接时应自行承担风险，仔细阅读并遵守第三方条款。
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              五、风险承担
            </h2>
            <p className="text-gray-600 mb-4">
              <strong>5.1 用户自行承担全部风险（核心条款）</strong>
              <br />
              用户在使用本平台服务过程中，因房主言论、其他用户行为或内容引起的任何风险、损失、纠纷、法律责任等，均由用户自行承担，与本平台无关。用户承诺并保证不会因使用本平台服务而向本平台提出任何形式的索赔、诉讼或要求。
            </p>
            <p className="text-gray-600 mb-4">
              <strong>5.2 信息安全风险</strong>
              <br />
              用户应自行保护个人信息安全，采取必要的安全措施防止个人信息泄露、被盗或被滥用。本平台不承担因用户个人信息泄露、被盗或被滥用导致的任何损失，包括但不限于财产损失、名誉损失等。
            </p>
            <p className="text-gray-600 mb-4">
              <strong>5.3 交易风险</strong>
              <br />
              用户在本平台进行的任何交易（包括但不限于会员购买、捐赠、打赏、付费服务等）均存在风险，包括但不限于支付失败、交易延迟、资金损失等风险。用户应仔细确认交易信息，谨慎进行交易，认真阅读交易条款。本平台不对交易过程中的任何损失、纠纷承担责任。
            </p>
            <p className="text-gray-600 mb-4">
              <strong>5.4 服务中断风险</strong>
              <br />
              本平台可能因技术故障、系统维护、升级、网络攻击、第三方服务中断、不可抗力等原因导致服务暂时不可用、数据丢失或延迟。用户应理解并接受这种风险，本平台不对由此造成的任何损失、直接或间接损害承担责任。
            </p>
            <p className="text-gray-600 mb-4">
              <strong>5.5 内容风险</strong>
              <br />
              用户可能因接触本平台上的某些内容而产生心理、情绪或经济上的不适或损失。用户应自行评估内容的适用性，必要时寻求专业建议。本平台不对因接触平台内容导致的任何损失或不适承担责任。
            </p>
            <p className="text-gray-600 mb-4">
              <strong>5.6 法律风险</strong>
              <br />
              用户应自行了解并遵守所在地区关于网络言论、投资交易的相关法律法规。因违反法律法规导致的法律责任，由用户自行承担。
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              六、服务费用与支付
            </h2>
            <p className="text-gray-600 mb-4">
              6.1 本平台提供的部分服务可能需要支付费用，具体费用标准以平台公示为准。用户使用付费服务即表示同意按照公示的费用标准支付费用。
            </p>
            <p className="text-gray-600 mb-4">
              6.2 用户应按照平台规定的方式支付费用。支持多种支付方式，包括但不限于USDT（TRC20、ERC20）等加密货币支付。支付完成后，费用不予退还，除非另有明确规定或法律法规要求。
            </p>
            <p className="text-gray-600 mb-4">
              6.3 用户应对其支付行为负责，确保支付账户有足够的资金或信用额度。因支付账户余额不足、支付被拒绝等导致的交易失败，由用户自行承担责任。
            </p>
            <p className="text-gray-600 mb-4">
              6.4 本平台保留随时调整服务费用的权利，调整后的费用标准将在平台公示。对于已支付费用的服务，不受影响。
            </p>
            <p className="text-gray-600 mb-4">
              6.5 因加密货币价格波动可能导致服务费用的实际价值发生变化，本平台不对加密货币价格波动导致的任何损失承担责任。
            </p>
            <p className="text-gray-600 mb-4">
              6.6 用户理解并同意，加密货币交易具有不可逆性，一旦完成转账，原则上无法撤销或退款。如需退款，应按照平台退款政策申请。
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              七、平台权利与义务
            </h2>
            <p className="text-gray-600 mb-4">
              7.1 本平台有权根据法律法规要求、主管部门指令或自身判断，删除、屏蔽、隐藏违规内容或限制、暂停、终止违规用户使用服务。
            </p>
            <p className="text-gray-600 mb-4">
              7.2 本平台有权对用户发布的内容进行审核、编辑、修改或删除，但不对审核的完整性和及时性做出保证。
            </p>
            <p className="text-gray-600 mb-4">
              7.3 本平台有义务维护平台的正常运行，采取合理的安全措施保障用户数据安全，但不对数据丢失、安全事件等承担绝对责任。
            </p>
            <p className="text-gray-600 mb-4">
              7.4 本平台有义务向用户提供必要的技术支持和服务说明，但不对服务质量做出绝对保证。
            </p>
            <p className="text-gray-600 mb-4">
              7.5 本平台有权制定、修改平台规则、管理规定等规范性文件，用户应遵守这些规定。
            </p>
            <p className="text-gray-600 mb-4">
              7.6 本平台有权在必要时对平台进行维护、升级或调整，可能导致服务暂时中断。
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              八、隐私政策
            </h2>
            <p className="text-gray-600 mb-4">
              8.1 本平台尊重用户隐私，将按照隐私政策的规定收集、使用、存储、保护用户的个人信息。
            </p>
            <p className="text-gray-600 mb-4">
              8.2 用户应仔细阅读隐私政策，了解个人信息的收集范围、使用方式、保护措施等内容。
            </p>
            <p className="text-gray-600 mb-4">
              8.3 用户使用本平台服务即表示同意桃花坛按照隐私政策处理用户的个人信息。
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              九、知识产权
            </h2>
            <p className="text-gray-600 mb-4">
              9.1 本平台的名称、标识、设计、界面、功能等知识产权归桃花坛所有，未经授权不得使用、复制、修改或传播。
            </p>
            <p className="text-gray-600 mb-4">
              9.2 用户在本平台发布的内容（包括文字、图片、音频、视频等），用户保留其知识产权，但授予本平台在全球范围内免费、非独占的使用权，用于平台的运营和展示。
            </p>
            <p className="text-gray-600 mb-4">
              9.3 如用户发现本平台上有侵犯自己知识产权的内容，可以向本平台提交侵权通知，本平台将根据法律法规进行处理。
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              十、免责声明
            </h2>
            <p className="text-gray-600 mb-4">
              10.1 本平台对因不可抗力、第三方原因或其他非本平台过错导致的服务中断、数据丢失、系统故障、交易失败等不承担责任。
            </p>
            <p className="text-gray-600 mb-4">
              10.2 本平台不对用户在使用服务过程中产生的任何间接损失、附带损失、后果性损失、惩罚性赔偿或精神损害赔偿承担责任，即使本平台已被告知可能发生此类损失的可能性。
            </p>
            <p className="text-gray-600 mb-4">
              10.3 本平台不对用户之间因使用服务产生的任何纠纷、争议或损失承担责任。用户之间的纠纷应由双方自行解决。
            </p>
            <p className="text-gray-600 mb-4">
              10.4 本平台不对因网络原因、黑客攻击、系统故障、第三方服务中断等导致的任何损失承担责任。
            </p>
            <p className="text-gray-600 mb-4">
              10.5 本协议中的免责声明在法律允许的最大范围内有效。
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              十一、协议修改与终止
            </h2>
            <p className="text-gray-600 mb-4">
              11.1 本平台保留随时修改本协议的权利。修改后的协议将在平台公告，修改内容自公告之日起生效。
            </p>
            <p className="text-gray-600 mb-4">
              11.2 用户继续使用服务即视为同意修改后的协议。如果用户不同意修改后的协议，应停止使用本平台服务。
            </p>
            <p className="text-gray-600 mb-4">
              11.3 用户可以随时停止使用本平台服务，账号注销后服务终止。
            </p>
            <p className="text-gray-600 mb-4">
              11.4 本平台有权根据法律法规、主管部门要求或本协议规定终止向用户提供部分或全部服务，无需承担违约责任。
            </p>
            <p className="text-gray-600 mb-4">
              11.5 账号被终止后，用户仍应对其在终止前发布的内容承担责任。
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              十二、法律适用与争议解决
            </h2>
            <p className="text-gray-600 mb-4">
              12.1 本协议的订立、执行和解释均适用中华人民共和国法律。
            </p>
            <p className="text-gray-600 mb-4">
              12.2 因本协议引起的或与本协议有关的任何争议，双方应首先通过友好协商解决；协商不成的，任何一方均可向有管辖权的人民法院提起诉讼。
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              十三、其他条款
            </h2>
            <p className="text-gray-600 mb-4">
              13.1 本协议的解释权归桃花坛所有。
            </p>
            <p className="text-gray-600 mb-4">
              13.2 本协议未尽事宜，参照国家法律法规、行业惯例和平台其他规定执行。
            </p>
            <p className="text-gray-600 mb-4">
              13.3 如本协议与国家法律法规冲突，以法律法规为准，但不影响其他条款的效力。
            </p>
            <p className="text-gray-600 mb-4">
              13.4 本协议各条款的标题仅为阅读方便，不影响条款内容的解释。
            </p>

            <div className="mt-12 p-6 bg-yellow-50 border border-yellow-200 rounded-lg">
              <p className="text-yellow-800 font-medium mb-2">⚠️ 重要提示（请务必仔细阅读）</p>
              <p className="text-yellow-700 text-sm mb-2">
                请您在使用本平台服务前仔细阅读本协议的全部内容。通过点击"同意"按钮或使用本平台服务，即表示您已阅读、理解并同意遵守本协议的全部条款。
              </p>
              <p className="text-yellow-700 text-sm mb-2">
                本协议旨在明确平台与用户之间的权利义务关系，特别是强调以下核心原则：
              </p>
              <ul className="text-yellow-700 text-sm list-disc list-inside mb-2">
                <li>房主责任独立：房主在房间内发表的任何言论均为个人行为，与平台无关</li>
                <li>平台不参与内容：平台不对用户发表的内容负责</li>
                <li>真实性不做研判：平台不验证信息的真实性</li>
                <li>投资风险自担：任何投资决策由用户自行做出，盈亏自负</li>
                <li>用户自行承担所有风险：因使用平台服务产生的任何损失由用户自行承担</li>
              </ul>
              <p className="text-yellow-700 text-sm">
                如果您不同意本协议的任何条款，请不要使用本平台服务。
              </p>
            </div>

            <div className="mt-8 p-4 bg-gray-50 rounded-lg">
              <p className="text-gray-500 text-center text-sm">
                桃花坛服务协议 v1.0
              </p>
              <p className="text-gray-400 text-center text-xs mt-1">
                最后更新日期：2026年5月
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;